/* Enlaces al catálogo ya filtrado:
   ?relleno=gel          -> marca ese relleno y abre los filtros
   ?ver=color | tamano | relleno -> abre los filtros y baja hasta ese grupo (los productos quedan a la vista) */
(function () {
  var params = new URLSearchParams(location.search);
  var wanted = params.get('relleno');
  var ver = params.get('ver');
  if (!wanted && !ver) return;
  var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); };
  var groupKey = { color: 'color', tamano: 'size', relleno: 'fill' };
  function openPanel(root) {
    var panel = root.querySelector('[data-sq-panel]');
    var tg = root.querySelector('[data-sq-toggle]');
    if (panel && tg && !panel.classList.contains('is-open')) tg.click();
  }
  function apply() {
    var root = document.querySelector('[data-sq-flt]');
    if (!root) return false;
    if (wanted) {
      var chip = Array.prototype.find.call(root.querySelectorAll('[data-sq-f="fill"]'), function (b) { return norm(b.dataset.v) === norm(wanted); });
      if (!chip) return false;
      if (chip.getAttribute('aria-pressed') !== 'true') chip.click();
      if (chip.getAttribute('aria-pressed') !== 'true') return false;
      openPanel(root);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    }
    var key = groupKey[norm(ver)];
    if (!key) return true;
    var first = root.querySelector('[data-sq-f="' + key + '"]');
    if (!first) return false;
    openPanel(root);
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var grp = first.closest('.sq-flt__grp');
    if (grp) grp.classList.add('is-hint');
    return true;
  }
  var tries = 0;
  (function loop() {
    if (apply() || ++tries > 30) return;
    setTimeout(loop, 250);
  })();
})();
